import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { getWeblocationPathGroupWithSiteConfig } from "../util/share";

interface Token {
    key: string;
    value: string;
}

export class LocalizedToken {
    private static instance: LocalizedToken;
    static getInstance(): LocalizedToken {
        if (!LocalizedToken.instance) {
            LocalizedToken.instance = new LocalizedToken();
        }else {
            // Instance already exists, so call init on it
            LocalizedToken.instance.init();
        }
        return LocalizedToken.instance;
    }
    constructor() {
        this.init();
    }

    public init(): void {
        //In localized header National page, local siteconfig token - token_details_without_curlybraces to be fetched and replace the key with value in the body component
        const main = document.getElementById("main");
        if (!main) return;
        this.getLocalTokenInfo();
    }

    public async getLocalTokenInfo() {
        try {
            const weblocation_path_group_url: string = await getWeblocationPathGroupWithSiteConfig();
            if (!weblocation_path_group_url) { return };
            const resp = await getCachedAPIResponse(weblocation_path_group_url, apiCaching.SiteConfig, false);
            if (!resp || !Array.isArray(resp?.token_details_without_curlybraces)) return;
            const token_details_without_curlybraces: Token[] = resp.token_details_without_curlybraces;
            const mainElement = document.getElementById("main");
            if (mainElement && Array.isArray(token_details_without_curlybraces)) {
                // Filter and build a token map for fast lookup
                const tokenMap = this.buildTokenMap(token_details_without_curlybraces);

                // If no valid tokens, exit early
                if (Object.keys(tokenMap).length === 0) return;

                // One regex to match all keys
                const tokenRegex = new RegExp(Object.keys(tokenMap).join('|'), 'gi');

                const treeWalker = document.createTreeWalker(mainElement, NodeFilter.SHOW_TEXT, null);

                let node: Text | null;
                while ((node = treeWalker.nextNode() as Text | null)) {
                    const originalText = node.textContent;
                    if (!originalText || !tokenRegex.test(originalText)) continue;

                    // Replace all keys using the map
                    const replacedText = originalText.replace(tokenRegex, (matched) => {
                        const key = Object.keys(tokenMap).find(k => k.toLowerCase() === matched.toLowerCase());
                        return key ? tokenMap[key] : matched;
                    });

                    node.textContent = replacedText;
                }

            }
        } catch (e) {
            console.error("SiteConfig loading failed:", e);
        }

    }

    // Function to build a map from tokens
    private buildTokenMap(tokens: Token[]): Record<string, string> {
        return tokens.reduce((map, token) => {
            const key = token?.key?.trim();
            const value = typeof token?.value === 'string' ? token.value.trim() : '';
            if (key && value) {
                map[key] = value;
            }
            return map;
        }, {} as Record<string, string>);
    }
}
export async function fetchLocalTokenInfo() {
    return LocalizedToken.getInstance().getLocalTokenInfo();
}